import { Diagram, Zone, ZoneValidationError } from 'models';

import { checkFaultCapacitanceSize } from './fault-capacitance-size';
import { checkFaultConnectionInductance } from './fault-connection-inductance';
import { checkFaultConnectionResistance } from './fault-connection-resistance';
import { checkFaultEndpointCapacitanceVoltage } from './fault-endpoint-capacitance-voltage';
import { checkFaultNegativeValues } from './fault-negative-values';

type Props = { diagram: Diagram; zones: Zone[]; controlZones: Zone[] };

const faultZoneValidator = (props: Props): ZoneValidationError[] => {
    return [
        ...checkFaultEndpointCapacitanceVoltage(props),
        ...checkFaultConnectionResistance({ diagram: props.diagram, zones: props.zones }),
        ...checkFaultCapacitanceSize({ diagram: props.diagram, zones: props.zones }),
        ...checkFaultConnectionInductance({ diagram: props.diagram, zones: props.zones }),
        ...checkFaultNegativeValues({ diagram: props.diagram, zones: props.zones }),
    ];
};

export { faultZoneValidator };
